import * as Yup from "yup";
//signin validation form
export const Signinvalidationschema = Yup.object({
  user_email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  user_password: Yup.string().required("Password is required"),
});
//client login
export const Signinclientvalidationschema = Yup.object({
  client_email: Yup.string().required("Email is required"),
  client_password: Yup.string().required("Password is required"),
});
//technition login
export const Signintechnitionvalidationschema = Yup.object({
  techn_username: Yup.string().required("Username is required"),
  techn_password: Yup.string().required("Password is required"),
});
//resetlink validation form
export const Resetlinkvalidationschema = Yup.object({
  user_email: Yup.string().email("Invalid email address").required("Required"),
  user_name: Yup.string(),
  resetlink: Yup.string(),
});
//password reset validation form
export const Passwordupdatevalidationschema = Yup.object({
  user_email: Yup.string(),
  user_password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("user_password"), null], "Confirm Password does not match"),
});
//signup validation form
export const Signupvalidationschema = Yup.object({
  user_name: Yup.string()
    .min(5, "Must be 5 characters or more")
    .max(15, "Must be 15 characters or less")
    .required("Required"),
  user_fullname: Yup.string()
    .min(3, "Must be 3 characters or more")
    .max(20, "Must be 20 characters or less")
    .required("Required"),
  user_email: Yup.string().email("Invalid email address").required("Required"),
  user_password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("user_password"), null], "Confirm Password does not match"),
  acceptTerms: Yup.bool().oneOf([true], "Accept Terms is required"),
});
//user validation form
export const Uservalidationschema = Yup.object().shape({
  user_id: Yup.string(),
  user_name: Yup.string().required("Required"),
  user_status: Yup.string(),
});
//principal validation form
export const Principalvalidationschema = Yup.object().shape({
  principal_id: Yup.string(),
  client_id: Yup.string().required("Required"),
  principal_name: Yup.string().required("Required"),
  principal_username: Yup.string().required("Required"),
  principal_password: Yup.string().required("Required"),
  principal_address: Yup.string(),
  principal_status: Yup.string(),
  principal_location: Yup.string().required("Required"),
  user_name: Yup.string(),
});
export const Usersvalidationschema = Yup.object().shape({
  user_id: Yup.string(),
  user_name: Yup.string()
    .min(5, "Must be 5 characters or more")
    .max(15, "Must be 15 characters or less")
    .required("Required"),
  user_fullname: Yup.string()
    .min(3, "Must be 3 characters or more")
    .max(20, "Must be 20 characters or less")
    .required("Required"),
  user_email: Yup.string().email("Invalid email address").required("Required"),
  user_password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  user_phone: Yup.string(),
  user_address: Yup.string(),
  user_role: Yup.string().required("Required"),
  user_status: Yup.string().required("Required"),
});
//employee validation form
export const Clientvalidationschema = Yup.object().shape({
  client_id: Yup.string(),
  client_fullname: Yup.string().required("Required"),
  client_username: Yup.string()
    .required("Required")
    .min(5, "Username must be at least 6 characters")
    .max(20, "Username must not exceed 20 characters")
    .matches(/^[A-Za-z, ]+$/, "Username is invalid only allowed text"),
  client_email: Yup.string()
    .email("Invalid email address")
    .required("Required"),
  client_phone: Yup.string().required("Required"),
  client_address: Yup.string().required("Required"),
  client_password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  client_role: Yup.string().required("Required"),
  client_start_at: Yup.string().required("Required"),
  client_end_at: Yup.string().required("Required"),
  client_status: Yup.string().required("Required"),
  user_name: Yup.string(),
});
//technition validation form
export const Technitionvalidationschema = Yup.object().shape({
  techn_id: Yup.string(),
  techn_fullname: Yup.string().required("Required"),
  techn_username: Yup.string()
    .required("Required")
    .min(5, "Username must be at least 6 characters")
    .max(20, "Username must not exceed 20 characters")
    .matches(/^[A-Za-z, ]+$/, "Username is invalid only allowed text"),
  techn_email: Yup.string().email("Invalid email address").required("Required"),
  techn_phone: Yup.string().required("Required"),
  techn_address: Yup.string().required("Required"),
  techn_password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  techn_role: Yup.string().required("Required"),
  techn_status: Yup.string().required("Required"),
});
//category validation form
export const Categoryvalidationschema = Yup.object().shape({
  category_id: Yup.string(),
  category_name: Yup.string().required("Required"),
  category_type: Yup.string().required("Required"),
  category_status: Yup.string(),
});
//clientcategory validation form
export const Clientcategoryvalidationschema = Yup.object().shape({
  category_id: Yup.string(),
  category_name: Yup.string().required("Required"),
  client_id: Yup.string().required("Required"),
  category_type: Yup.string().required("Required"),
  category_status: Yup.string(),
});
//Checklist validation form
export const Checklistvalidationschema = Yup.object().shape({
  checklist_id: Yup.string(),
  checklist_name: Yup.string().required("Required"),
  checklist_category: Yup.string(),
  checklist_status: Yup.string(),
  user_name: Yup.string(),
});
//Checklist validation form
export const Servicingvalidationschema = Yup.object().shape({
  servicing_id: Yup.string(),
  servicing_name: Yup.string().required("Required"),
  servicing_price: Yup.string().required("Required"),
  servicing_status: Yup.string(),
  user_name: Yup.string(),
});
//Aircon validation form
export const Airconvalidationschema = Yup.object().shape({
  aircon_id: Yup.string(),
  aircon_name: Yup.string(),
  client_id: Yup.string().required("Required"),
  aircon_building: Yup.string(),
  aircon_block: Yup.string().required("Required"),
  aircon_level: Yup.string().required("Required"),
  aircon_location: Yup.string().required("Required"),
  aircon_type: Yup.string().required("Required"),
  total_unit: Yup.string().required("Required"),
  aircon_remark: Yup.string(),
  aircon_status: Yup.string(),
});
//Aircon unit validation form
export const Airconunitvalidationschema = Yup.object().shape({
  au_id: Yup.string(),
  au_name: Yup.string(),
  aircon_id: Yup.string(),
  client_id: Yup.string().required("Required"),
  au_type: Yup.string().required("Required"),
  au_category: Yup.string(),
  au_brand: Yup.string().required("Required"),
  au_btu: Yup.string(),
  au_model_no: Yup.string(),
  au_serial_no: Yup.string(),
  au_status: Yup.string(),
  user_name: Yup.string(),
});
//Airconhistory validation form
export const Airconhistoryvalidationschema = Yup.object().shape({
  ah_id: Yup.string(),
  client_id: Yup.string().required("Required"),
  aircon_id: Yup.string().required("Required"),
  ah_name: Yup.string(),
  checked_list: Yup.string(),
  service_list: Yup.string(),
  total_amount: Yup.string(),
  additional_amount: Yup.string(),
  ah_type: Yup.string().required("Required"),
  ah_remark: Yup.string().required("Required"),
  approvedBy: Yup.string(),
  servicedBy: Yup.string(),
  ah_status: Yup.string().required("Required"),
  user_name: Yup.string(),
});
//Airconhistory status validation form
export const Airconhistorystatusvalidationschema = Yup.object().shape({
  status_id: Yup.string(),
  ah_id: Yup.string(),
  status_name: Yup.string().required("Required"),
  status_remark: Yup.string(),
  status_remark: Yup.string(),
  approval_signature: Yup.string(),
  created_type: Yup.string(),
  user_name: Yup.string(),
});
//Checklist validation form
export const Locationvalidationschema = Yup.object().shape({
  location_id: Yup.string(),
  client_id: Yup.string().required("Required"),
  location_name: Yup.string().required("Required"),
  location_address: Yup.string().required("Required"),
  location_status: Yup.string(),
  user_name: Yup.string(),
});

//GENERAL ALL VALIDATION
export const validationSchema = Yup.object({
  firstName: Yup.string()
    .required("Firstname is required")
    .matches(/^[A-Za-z, ]+$/, "Firstname is invalid only allowed text"),
  lastName: Yup.string().required("Lastname is required"),
  userName: Yup.string()
    .required("Username is required")
    .min(6, "Username must be at least 6 characters")
    .max(20, "Username must not exceed 20 characters"),
  dob: Yup.string().required("Date of Birth is required"),
  gender: Yup.string().required("Gender is required"),
  email: Yup.string().required("Email is required").email("Email is invalid"),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Confirm Password does not match"),
  acceptTerms: Yup.bool().oneOf([true], "Accept Terms is required"),
});
